<template>
    <div v-if ="status === 'COMPLETED'" @click.stop="() => dialog = true">
        <v-btn :color="dateRange.length === 2 ? '#009688' : '#9e9e9e'" class="px-0"><v-icon color="white" medium >mdi-calendar-clock</v-icon></v-btn>
        <v-dialog v-model="dialog" max-width="400px">
            <v-card>
                <v-card-title class="headline">Ολοκλήρωση {{ label }}</v-card-title>
                <v-date-picker
                    v-model="dateRange"
                    range
                    color="#0047AB"
                    locale="el"
                    class="datepicker"
                ></v-date-picker>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
    import momentTimezone from 'moment-timezone'

    export default {
        props: {
            label: {
                type: String,
                required: true
            },
            status: {
                type: [String, Number],
                required: true
            },
            from: {
                type: String,
                required: true
            },
            completedRange: {
                type: Object,
                require: true
            }
        },
        watch: {
            completedRange: {
                handler(newVal, oldVal) {
                    if (newVal && newVal.range?.length === 2) {
                        this.dateRange = newVal.range
                    }
                },
                immediate: true
            },
            dateRange: {
                handler(newVal, oldVal) {
                    const sorted = newVal.length === 2 ? [...newVal].sort((a, b) => a.localeCompare(b)) : []
                    if (sorted.length === 2) {
                        this.filterDateText = this.formatDate(sorted[0]) + ' ~ ' + this.formatDate(sorted[1])
                    } else {
                        this.filterDateText = ''
                    }
                    this.$emit('selected', { text: this.filterDateText, range: this.transformToUtc(sorted), from: this.from })
                },
                deep: true
            }
        },
        data() {
            return {
                dateRange: [],
                dialog: false,
                filterDateText: ''
            }
        },
        methods: {
            formatDate(date) {
                return momentTimezone(date).utc().tz('Europe/Athens').format('YYYY-MM-DD').toString()
            },
            transformToUtc(range) {
                if (range.length !== 2) {
                    return []
                }
                return [momentTimezone(range[0] + ' 00:00:00').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString(), momentTimezone(range[1] + ' 23:59:59').tz('Europe/Athens').utc().format('YYYY-MM-DD[T]HH:mm:ss[Z]').toString()]
            }
        }
    }
</script>
<style scoped>
.datepicker {
    width: 100%;
}
.headline {
    display: flex;
    justify-content: center;
    font-size: 1.3rem !important;
}
</style>
